import { getApiBaseUrl } from '../utils/apiBase';

async function startExecuteMyMutation(id: number, userAccountId: string) {
  const apiBase = getApiBaseUrl();
  const result = await fetch(`${apiBase}/api/views/${id}`, {
    method: 'DELETE',
    headers: new Headers({
      Accept: 'application/json',
      'x-hasura-user-id': userAccountId,
    }),
  });
  const jsonResult = await result.json();
  if (jsonResult?.errors) {
    console.error(jsonResult.errors);
    return { errors: jsonResult.errors };
  }
  return jsonResult;
}

export const deleteQuery = (id: number, userAccountId: string) => {
  return startExecuteMyMutation(id, userAccountId);
};
